import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  public menuListRef: firebase.database.Reference;
  constructor(private db: AngularFireDatabase) { 
    this.menuListRef = db.database.ref(`/com_menus`);
  }

  getPages(){
    return this.menuListRef.child('item').orderByChild(`lft`);
  }

  getMenuId(alias) {
    return this.menuListRef.child('item').child(`${alias}`).orderByChild(`${alias}/ordering`);
  }
}
